export default __webpack_public_path__ + "static/media/andres.f44d4cb5.png";